import React from "react";
import { Outlet } from "react-router-dom";
import RmHeader from "./Header/RmHeader";
import RmUnderDevelopment from "./RmUnderDevelopment";
import HelperService from "../../Services/HelperService";

const RmPortalMain = () => {
  if (HelperService.isRmInDevelopment()) {
    return <RmUnderDevelopment />;
  }

  return (
    <div id="main-app" className="layout-veritcle-menu sidebar-collapsed">
      <div className="app-body" style={{ marginLeft: 0, width: "100%" }}>
        <RmHeader />
        <div className="app-page pt-4 mt-5">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default RmPortalMain;

